import API_BASE_URL from './apiConfig'

/**
 * Send a message to Fabritech AI assistant
 * @param {string} message
 * @param {Array<{role: string, content: string}>} history
 */
export const sendChatMessage = async (message, history = []) => {
  const response = await fetch(`${API_BASE_URL}/chat`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      message,
      history: history.slice(-12).map(({ role, content }) => ({ role, content })),
    }),
  })

  if (!response.ok) {
    const data = await response.json().catch(() => ({}))
    throw new Error(data.error || 'Unable to reach the assistant right now')
  }

  return response.json()
}

export default { sendChatMessage }
